<div class="config-content-container surface-0">
    @if (initialized && activeNavigationItem) {

        @if (activeNavigationItem.action == 'frequencies') {
            @if (widgets?.frequencyWidget?.widgetData) {
                <mvs-widget
                        [widgetData]="widgets?.frequencyWidget?.widgetData"
                        (onObjectSelect)="onFrequencySelect($event)"
                ></mvs-widget>
            }
        }

        @if (activeNavigationItem.action == 'paymentMoments') {
            @if (widgets?.paymentMomentWidget?.widgetData) {
                <mvs-widget
                        [widgetData]="widgets?.paymentMomentWidget?.widgetData"
                        (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        }

        @if (activeNavigationItem.action == 'paymentTypes') {
            @if (widgets?.paymentTypeWidget?.widgetData) {
                <mvs-widget
                        [widgetData]="widgets?.paymentTypeWidget?.widgetData"
                        (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        }

        @if (activeNavigationItem.action == 'roundingRules') {
            @if (widgets?.roundingRuleWidget?.widgetData) {
                <mvs-widget
                        [widgetData]="widgets?.roundingRuleWidget?.widgetData"
                        (onObjectSelect)="onRoundingRuleSelect($event)"
                ></mvs-widget>
            }
        }

    }
</div>
